import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icons-arrow-down-09618",
  "use": "icons-arrow-down-09618-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icons-arrow-down-09618\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.814 7.182 1.752 8.244l5.124 5.124L12 18.492l5.124-5.124 5.124-5.124-1.062-1.062-1.062-1.062-4.062 4.062L12 14.244l-4.062-4.062L3.876 6.12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol